/** @format */

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

//import table data
import {
  tableColumnDrivers,
  tableColumnMangers,
} from "../../components/table/col-data";
import { useEffect, useState } from "react";
import { SecondNav } from "../../components/second-nav";
import { useDispatch, useSelector } from "react-redux";
import { addManger } from "../../store/stateSlice";
import AddManger from "../../components/pops/mangers/AddManger";
import Table from "../../components/Table2";
import { tableMangers } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { getAllManagers } from "../../services/managers";
import { Spinner1 } from "../../components/spinners/Spinner1";
import Pagination from "../../components/Pagination";
const Mangers = () => {
  const [isOpen, setOpen] = useState(false);
  const [active, setActive] = useState("all");

  const { allManagers, loading } = useSelector((state) => state.managers);
  const dispatch = useDispatch();
  useEffect(() => {
    getManagers(1);
  }, []);
  const getManagers = () => {
    dispatch(getAllManagers(1));
  };
  const getPageData = (num) => {
    dispatch(getAllManagers(num));
  };
  return (
    <NavbarAndSidebar>
      {loading && <Spinner1 />}
      <AddManger
        isOpen={isOpen}
        toggleModal={() => setOpen(false)}
        getManagers={getManagers}
      />

      <div className='flex-between'>
        <HeadTitle title='المشرفين' />
        <button className='btn btn__primary' onClick={() => setOpen(true)}>
          اضافه مشرف
        </button>
      </div>
      <SecondNav from='mangers' setActive={setActive} active={active} />
      <div className='mb__small' />
      {active === "all" && (
        <Table
          data={allManagers.data}
          header={tableMangers}
          link='/mangers/'
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='mangers'
        />
      )}
      {active === "varified-mangers" && (
        <Table
          data={allManagers.data.filter(
            (manager) => manager.status === "active"
          )}
          header={tableMangers}
          link='/mangers/'
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='mangers'
        />
      )}
      {active === "block-mangers" && (
        <Table
          data={allManagers.data.filter(
            (manager) => manager.status !== "active"
          )}
          header={tableMangers}
          link='/mangers/'
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='mangers'
        />
      )}
      {allManagers?.pagination?.totalPages > 1 ? (
        <Pagination
          pagination={allManagers?.pagination}
          getPageData={getPageData}
        />
      ) : null}
    </NavbarAndSidebar>
  );
};
export default Mangers;
